// src/pages/About.js
import React from 'react';
import { FaAsterisk, FaBolt, FaChartLine } from 'react-icons/fa';
import SolanaLogo from '../assets/solana.png';
import PumpfunLogo from '../assets/pf.png';
import RaydiumLogo from '../assets/raydium.png';
import MeteoraLogo from '../assets/meteora.png';
import OpenAILogo from '../assets/openai.png';

const About = () => {
    return (
        <div className="text-gray-200">
            {/* Hero Section */}
            <section className="flex flex-col items-center text-center py-6 px-4 space-y-3">
                <div className="flex items-center space-x-2 text-base sm:text-lg font-medium text-yellow-400">
                    <FaAsterisk /> {/* Changed emoji */}
                    <span>AI-Powered Trading on the Solana Ecosystem</span>
                </div>
                <h1 className="text-2xl sm:text-3xl font-bold text-white">
                    Maximize Your Solana Portfolio with Automated Profit Strategies
                </h1>
                <p className="text-gray-400 max-w-md text-sm sm:text-base">
                    Our bots utilize advanced AI to drive returns in the Solana ecosystem, focusing on high-growth liquidity, stealth coin launches, and optimized entry and exit points.
                </p>
            </section>

            {/* Powered By Section */}
            <section className="py-4 px-4 text-center">
                <p className="text-gray-400 text-sm sm:text-base mb-3">Powered by leading technologies and platforms</p>
                <div className="flex justify-center flex-wrap space-x-4 sm:space-x-6">
                    {[SolanaLogo, PumpfunLogo, RaydiumLogo, MeteoraLogo, OpenAILogo].map((logo, index) => (
                        <img key={index} src={logo} alt="Partner logo" className="h-6 sm:h-8" />
                    ))}
                </div>
            </section>

            {/* Features Section */}
            <section className="py-6 px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Raydium LP Farming Bot */}
                    <div className="bg-black text-gray-200 p-4 rounded-lg shadow-lg w-full max-w-xs mx-auto border border-white">
                        <h3 className="text-lg font-semibold">Raydium LP Farming Bot</h3>
                        <p className="text-gray-400 mt-2 text-xs sm:text-sm">
                            Utilizes high volatility in Raydium LPs, strategically entering and exiting pools for consistent passive income.
                        </p>
                        <div className="flex items-center space-x-2 mt-2">
                            <FaChartLine className="text-blue-500" size={16} />
                            <span className="text-base sm:text-lg font-bold text-white">+20% on Solana Portfolio</span>
                        </div>
                    </div>

                    {/* Token Scalping Bot */}
                    <div className="bg-black text-gray-200 p-4 rounded-lg shadow-lg w-full max-w-xs mx-auto border border-white">
                        <h3 className="text-lg font-semibold">Token Scalping Bot</h3>
                        <p className="text-gray-400 mt-2 text-xs sm:text-sm">
                            Automates buying and selling in new tokens, aiming to hit 100% profit on each cycle, with reinvested gains.
                        </p>
                        <ul className="mt-2 space-y-1 text-xs sm:text-sm">
                            <li className="flex justify-between">
                                <span>Auto-Buying</span>
                                <span className="text-green-400">Enabled</span>
                            </li>
                            <li className="flex justify-between">
                                <span>24/7 Scalping</span>
                                <span className="text-green-400">Active</span>
                            </li>
                            <li className="flex justify-between">
                                <span>Reinvestment</span>
                                <span className="text-green-400">Automated</span>
                            </li>
                        </ul>
                    </div>

                    {/* Organic Coin Launch Bot */}
                    <div className="bg-black text-gray-200 p-4 rounded-lg shadow-lg w-full max-w-xs mx-auto border border-white">
                        <h3 className="text-lg font-semibold">Organic Coin Launch Bot</h3>
                        <p className="text-gray-400 mt-2 text-xs sm:text-sm">
                            Deploys new coins on Solana with a stealthy approach to attract organic buyers and boost demand for strategic profit.
                        </p>
                        <ul className="mt-2 space-y-1 text-xs sm:text-sm">
                            <li className="flex justify-between">
                                <span>Stealth Launch</span>
                                <span className="text-green-400">Active</span>
                            </li>
                            <li className="flex justify-between">
                                <span>Supply Control</span>
                                <span className="text-green-400">Optimized</span>
                            </li>
                            <li className="flex justify-between">
                                <span>Buyer Attraction</span>
                                <span className="text-green-400">Enabled</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
